/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-prototype-builtins */
// Initialize dataframe-js module
import { DataFrame } from "dataframe-js";
import { GLOSSARY } from "../parameters/glossary";
export const getFolderNames = (parsed) => {
    let maskedfolderList = [];
    let targetfolderList = [];
    let targetTaskList = [];
    let targetKindList = [];
    for (let i = 0; i < parsed.data.length; i++) {
        if (parsed.data[i][0] == "maskerSoundFolder") {
            maskedfolderList = [...parsed.data[i]];
        }
        else if (parsed.data[i][0] == "targetSoundFolder") {
            targetfolderList = [...parsed.data[i]];
        }
        else if (parsed.data[i][0] == "targetTask") {
            targetTaskList = [...parsed.data[i]];
        }
        else if (parsed.data[i][0] == "targetKind") {
            targetKindList = [...parsed.data[i]];
        }
    }
    maskedfolderList.shift();
    targetfolderList.shift();
    targetTaskList.shift();
    targetKindList.shift();
    let folderAndTargetKindObjectList = [];
    // targetKind:Sound and targetTask:Detect needs masker and target folders
    if (maskedfolderList.length > 0 && targetfolderList.length > 0) {
        for (let i = 0; i < maskedfolderList.length; i++) {
            if (
            // targetKindList[i] === "vocoderPhrase" ||
            targetKindList[i] === "sound") {
                folderAndTargetKindObjectList.push({
                    maskerSoundFolder: maskedfolderList[i],
                    targetSoundFolder: targetfolderList[i],
                    targetTask: targetTaskList[i],
                    targetKind: targetKindList[i],
                });
            }
        }
    }
    else if (targetfolderList.length > 0) {
        for (let i = 0; i < targetfolderList.length; i++) {
            if (targetKindList[i] === "vocoderPhrase" ||
                targetKindList[i] === "sound") {
                folderAndTargetKindObjectList.push({
                    targetSoundFolder: targetfolderList[i],
                    targetTask: targetTaskList[i],
                    targetKind: targetKindList[i],
                });
            }
        }
    }
    //targetKind:Sound and targetTask:Identify needs target folder
    //remove duplicates
    maskedfolderList = [...new Set(maskedfolderList)];
    targetfolderList = [...new Set(targetfolderList)];
    //remove empty strings from the lists
    maskedfolderList = maskedfolderList.filter((item) => item !== "");
    targetfolderList = targetfolderList.filter((item) => item !== "");
    // console.log("maskerFolder",maskedfolderList)
    // console.log("targetFolder",targetfolderList)
    // let folderList: string[] = maskedfolderList.concat(targetfolderList);
    // folderList = folderList.filter(
    //   (item, pos) => folderList.indexOf(item) === pos
    // );
    // folderList = folderList.map((x) => x + ".zip");
    // return folderList;
    return {
        maskerSoundFolder: maskedfolderList,
        targetSoundFolder: targetfolderList,
        folderAndTargetKindObjectList: folderAndTargetKindObjectList,
    };
};
export const getCodeList = (parsed) => {
    let codeList = [];
    for (let i = 0; i < parsed.data.length; i++) {
        if (parsed.data[i][0] === "movieComputeJS") {
            codeList = [...parsed.data[i]];
            break;
        }
    }
    codeList.shift(); // remove the first column
    codeList = [...new Set(codeList)]; // remove duplicates
    codeList = codeList.filter((item) => item !== ""); // remove empty strings
    return codeList;
};
export const getImageNames = (parsed) => {
    let imageList = [];
    for (let i = 0; i < parsed.data.length; i++) {
        if (parsed.data[i][0] === "showImage") {
            imageList = [...parsed.data[i]];
            break;
        }
    }
    imageList.shift(); // remove the first column
    imageList = [...new Set(imageList)]; // remove duplicates
    imageList = imageList.filter((item) => item !== ""); // remove empty strings
    return imageList;
};
export const getFormNames = (parsed) => {
    let consentFormRow = [];
    let debriefFormRow = [];
    for (let i = 0; i < parsed.data.length; i++) {
        if (parsed.data[i][0] == "_consentForm") {
            consentFormRow = parsed.data[i];
        }
        else if (parsed.data[i][0] == "_debriefForm") {
            debriefFormRow = parsed.data[i];
        }
    }
    const formData = {};
    if (consentFormRow[1])
        formData["consentForm"] = consentFormRow[1];
    if (debriefFormRow[1])
        formData["debriefForm"] = debriefFormRow[1];
    return formData;
};
/**
 * Get list of fonts required with given font source
 * @param {Papa.ParseResult<string[]>} parsed
 * @param {string} fontSource
 * @returns {string[]}
 */
export const getFontNameListBySource = (parsed, fontSource) => {
    const fontList = [];
    let fontRow = [];
    let fontSourceRow = [];
    let foundFontSourceRow = false;
    for (let i = 0; i < parsed.data.length; i++) {
        if (parsed.data[i][0] == "font") {
            fontRow = parsed.data[i];
        }
        else if (parsed.data[i][0] == "fontSource") {
            fontSourceRow = parsed.data[i];
            foundFontSourceRow = true;
        }
    }
    let defaultFont = GLOSSARY["font"].default;
    let defaultFontSource = GLOSSARY["fontSource"].default;
    const getRowValues = (row, defaultValue) => row.map((s, i) => {
        if (i === 0)
            return "";
        if (s === "" || typeof s === "undefined")
            return defaultValue;
        return s;
    });
    fontRow = getRowValues(fontRow, defaultFont);
    fontSourceRow = getRowValues(fontSourceRow, defaultFontSource);
    for (let i = 0; i < fontRow.length; i++) {
        if (fontSourceRow[i].trim() == fontSource && !fontList.includes(fontRow[i]))
            fontList.push(fontRow[i]);
    }
    // do same thing for instructionFont
    let instructionFontRow = [];
    let instructionFontSourceRow = [];
    let foundInstructionFontSourceRow = false;
    for (let i = 0; i < parsed.data.length; i++) {
        if (parsed.data[i][0] == "instructionFont") {
            instructionFontRow = parsed.data[i];
        }
        else if (parsed.data[i][0] == "instructionFontSource") {
            instructionFontSourceRow = parsed.data[i];
            foundInstructionFontSourceRow = true;
        }
    }
    if (!foundInstructionFontSourceRow) {
        let defaultValue = GLOSSARY["instructionFontSource"].default;
        if (Array.isArray(defaultValue))
            defaultValue = defaultValue[0];
        for (let i = 0; i < instructionFontRow.length; i++)
            instructionFontSourceRow[i] = defaultValue;
        fontSourceRow[0] = "";
    }
    for (let i = 0; i < instructionFontRow.length; i++) {
        if (instructionFontSourceRow[i].trim() == fontSource &&
            !fontList.includes(instructionFontRow[i]))
            fontList.push(instructionFontRow[i]);
    }
    return [...fontList.filter((s) => s.length > 0)];
};
/**
 *
 * @param { Papa.ParseResult<string[]> } parsed
 * @returns { string[] }
 */
export const getTextList = (parsed) => {
    const textList = new Set();
    for (const parsedRow of parsed.data) {
        if (parsedRow[0] == "readingCorpus")
            for (const source of parsedRow.slice(1))
                textList.add(source.trim());
    }
    // Ignore empty strings
    return [...textList].filter((x) => x);
};
/**
 * Return a transposed copy of a 2D table.
 * CREDIT https://stackoverflow.com/questions/17428587/transposing-a-2d-array-in-javascript
 * @param {*[][]} nestedArray A 2D array (array of arrays of primitives)
 * @returns {*[][]} transposed Transposed transformation of nestedArray
 */
export const transpose = (nestedArray) => {
    const transposed = nestedArray[0].map((_, colIndex) => nestedArray.map((row) => row[colIndex]));
    return transposed;
};
/**
 * Check whether an array of file objects contains one with the name of the value of targetFileName
 * @param {File[]} fileList
 * @param {String} targetFileName
 * @returns {Boolean}
 */
export const fileListContainsFileOfName = (fileList, targetFileName) => {
    const isFileOfTargetName = (candidateFile) => candidateFile.name == targetFileName;
    return fileList.filter(isFileOfTargetName).length > 0;
};
/**
 * Given the content returned by PapaParse on our csv file, provide a dfjs Dataframe
 * @param {Object} parsedContent .csv file as parsed by PapaParse
 * @returns {dfjs.DataFrame}
 */
export const dataframeFromPapaParsed = (parsedContent) => {
    let parsedData = parsedContent.data;
    // Lack of a trailing comma was causing problems in some csv's. Pad with empty strings to fix.
    parsedData = padToLongestLength(parsedData);
    // Transpose, to get from Denis's row-major convention to the usual column-major
    const transposed = parsedData[0].map((_, colIndex) => parsedData.map((row) => row[colIndex]));
    // Separate out the column names from rows of values
    const data = transposed.slice(1); // Rows
    const columns = transposed[0]; // Header
    // Create and return the DataFrame
    return new DataFrame(data, columns);
};
/**
 * Damerau–Levenshtein of two strings
 * @see https://stackoverflow.com/questions/11919065/sort-an-array-by-the-levenshtein-distance-with-best-performance-in-javascript
 * @author James Westgate (https://stackoverflow.com/users/305319/james-westgate)
 * @param {String} s
 * @param {String} t
 * @returns
 */
export const levDist = (s, t) => {
    const d = []; //2d matrix
    // Step 1
    const n = s.length;
    const m = t.length;
    if (n == 0)
        return m;
    if (m == 0)
        return n;
    //Create an array of arrays in javascript (a descending loop is quicker)
    for (let i = n; i >= 0; i--)
        d[i] = [];
    // Step 2
    for (let i = n; i >= 0; i--)
        d[i][0] = i;
    for (let j = m; j >= 0; j--)
        d[0][j] = j;
    // Step 3
    for (let i = 1; i <= n; i++) {
        const s_i = s.charAt(i - 1);
        // Step 4
        for (let j = 1; j <= m; j++) {
            //Check the jagged ld total so far
            if (i == j && d[i][j] > 4)
                return n;
            const t_j = t.charAt(j - 1);
            const cost = s_i == t_j ? 0 : 1; // Step 5
            //Calculate the minimum
            let mi = d[i - 1][j] + 1;
            const b = d[i][j - 1] + 1;
            const c = d[i - 1][j - 1] + cost;
            if (b < mi)
                mi = b;
            if (c < mi)
                mi = c;
            d[i][j] = mi; // Step 6
            //Damerau transposition
            if (i > 1 && j > 1 && s_i == t.charAt(j - 2) && s.charAt(i - 2) == t_j) {
                d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + cost);
            }
        }
    }
    // Step 7
    return d[n][m];
};
export const addUniqueLabelsToDf = (df) => {
    if (!df.listColumns().includes("block")) {
        console.error("Experiment will fail. 'block' parameter not provided. Do not run experiment in this state.");
        return df;
    }
    const blocks = df.select("block").toArray();
    const blockCounts = {};
    const block_conditions = [];
    blocks.forEach((nestedBlock) => {
        const block = nestedBlock[0];
        if (blockCounts.hasOwnProperty(block)) {
            blockCounts[block] += 1;
        }
        else {
            blockCounts[block] = 1;
        }
        block_conditions.push(String(block) + "_" + String(blockCounts[block]));
    });
    df = df.withColumn("block_condition", (row, index) => block_conditions[index]);
    return df;
};
/**
 * @see https://stackoverflow.com/questions/175739/built-in-way-in-javascript-to-check-if-a-string-is-a-valid-number
 * @author Dan [https://stackoverflow.com/users/17121/dan]
 * @param str
 * @returns
 */
export const isNumeric = (str) => {
    if (typeof str != "string")
        return false; // we only process strings!
    return (!isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(str))); // ...and ensure strings of whitespace fail
};
/**
 * Element-wise check of whether two arrays are equal
 * @see https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript/16430730
 * @param {any[]} a
 * @param {any[]} b
 * @returns {boolean}
 */
export const arraysEqual = (a, b) => {
    if (a === b)
        return true;
    if (a == null || b == null)
        return false;
    if (a.length !== b.length)
        return false;
    // If you don't care about the order of the elements inside
    // the array, you should sort both arrays here.
    // Please note that calling sort on an array will modify that array.
    // you might want to clone your array first.
    for (let i = 0; i < a.length; ++i) {
        if (a[i] !== b[i])
            return false;
    }
    return true;
};
export const verballyEnumerate = (individuals) => {
    if (individuals.length === 1)
        return individuals[0];
    if (individuals.length === 2)
        return individuals[0] + " and " + individuals[1];
    let enumeratedString = "";
    for (let i = 0; i < individuals.length; i++) {
        if (i !== individuals.length - 1) {
            // Not last individual
            enumeratedString += String(individuals[i]) + ", ";
        }
        else {
            // Last individual
            enumeratedString += "and " + String(individuals[i]);
        }
    }
    return enumeratedString;
};
export const limitedEnumerate = (individuals, lengthLimit = 4) => {
    if (individuals.length <= lengthLimit)
        return verballyEnumerate(individuals);
    return individuals.slice(0, lengthLimit).join(", ") + "...";
};
export const getNumericalSuffix = (n) => {
    switch (Math.abs(Number(n))) {
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
};
/**
 * Robust check for whether a file is a CSV/XLSX file
 * https://developer.mozilla.org/en-US/docs/Web/API/File
 * @param {File} file File object to be checked
 * @returns {Boolean}
 */
export const isExpTableFile = (file) => {
    return file.name.includes("xlsx") || file.name.includes("csv");
};
export const addNewUnderscoreParam = (df, paramName, paramValue) => {
    const columnName = paramName[0] !== "_" ? "_" + paramName : paramName;
    if (df.listColumns().includes(columnName))
        return df;
    return df.withColumn(columnName, (_, i) => i === 0 ? paramValue : "");
};
export const addNewInternalParam = (df, paramName, paramValue) => {
    const columnName = paramName[0] !== "!" ? "!" + paramName : paramName;
    if (df.listColumns().includes(columnName))
        return df;
    if (Array.isArray(paramValue))
        return df.withColumn(columnName, (_, i) => paramValue[i]);
    return df.withColumn(columnName, (_, i) => paramValue);
};
/**
 * Takes a positive integer and returns the corresponding column name.
 * @SOURCE https://cwestblog.com/2013/09/05/javascript-snippet-convert-number-to-column-name/
 * @param {number} num  The positive integer to convert to a column name.
 * @return {string}  The column name.
 */
export const toColumnName = (num) => {
    for (var ret = "", a = 1, b = 26; (num -= a) >= 0; a = b, b *= 26) {
        const z = (num % b) / a;
        const y = parseInt(z.toString()) + 65;
        ret = String.fromCharCode(y) + ret;
    }
    return ret;
};
/**
 * Given a (zero-indexed) condition index (ie position in an array of all the block_condition values),
 * return the corresponding column name (where the first condition is found in column C of the experiment
 * table, following column A with the parameter name and column B with underscore parameter values).
 * @param conditionN
 * @return {string}
 */
export const conditionIndexToColumnName = (conditionN) => {
    return toColumnName(conditionN + 3);
};
/**
 * Given an array of arrays which may not be of the same length, pad each so that they are.
 * @param arrays {unknown[][]} Array of arrays
 * @param paddingValue {unknown} The value used to pad arrays to length
 * @returns {unknown[][]} Array of arrays, all of equal length
 */
const padToLongestLength = (arrays, paddingValue = "") => {
    const longestLength = Math.max(...arrays.map((array) => array.length));
    const paddedArrays = arrays.map((array) => [
        ...array,
        ...new Array(longestLength - array.length).fill(paddingValue),
    ]);
    return paddedArrays;
};
export const getDateAndTimeString = (date) => {
    // new Date() -> e.g., 2022-6-13_12-34-56
    return date
        .toLocaleString("zh-CN", { hour12: false })
        .replace(/\//g, "-")
        .replace(/:/g, "-")
        .replace(/ /g, "_");
};
/**
 * Predicate function, determine whether given parameter is an underscore (ie experiment-level) parameter
 * @param paramterName
 * @returns {boolean}
 */
export const isUnderscoreParameter = (paramterName) => {
    return paramterName[0] === "_";
};
// Return a column as a flat array
export const getColumnValues = (df, columnName) => {
    return df
        .select(columnName)
        .toArray()
        .map((x) => x[0]);
};
// Return a column as a flat array, with unspecified columns filled in with the default
// TODO should this just be the behavior of getColumnValues?
// TODO should this parse the output, ie with ParamReader.parse()?
export const getColumnValuesOrDefaults = (df, columnName) => {
    const presentParameters = df.listColumns();
    const rows = df.dim()[0];
    const defaultValue = GLOSSARY[columnName].default;
    if (presentParameters.includes(columnName))
        return getColumnValues(df, columnName).map((x) => typeof x === "undefined" || x === "" ? defaultValue : x);
    return new Array(rows).fill(defaultValue);
};
/**
 * Get set of all elements which aren't contiguous
 * @param a Array of values
 * @returns
 */
export const getNoncontiguousValues = (a) => {
    let previous = a[0];
    const seen = new Set();
    const noncontiguous = new Set();
    for (let i = 0; i < a.length; i++) {
        let current = a[i];
        if (current === "") {
            previous = current;
            continue;
        }
        if (current !== previous && seen.has(current))
            noncontiguous.add(current);
        seen.add(current);
        previous = current;
    }
    return noncontiguous;
};
/**
 * Predicate. Does there exists some element in the array which repeats noncontiguously?
 * @param a Array of values
 * @returns {boolean}
 */
export const valuesContiguous = (a) => {
    return getNoncontiguousValues(a).size === 0;
};
/**
 * Predicate. Is the given string the name of a blockShuffleGroups parameter?
 * @param s {string}
 * @returns {boolean}
 */
export const isBlockShuffleGroupingParam = (s) => {
    return /blockShuffleGroups\d$/.test(s);
};
